import Enum from "./Enum";

export default Enum.create( {
	LEAD: "LEAD",
	MEMBER: "MEMBER",
} );
